// src/components/LandingPage.js (Versão 2.0 - "100%")

import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiBarChart2, FiTarget, FiRepeat, FiLogIn, FiArrowRight, FiShield } from 'react-icons/fi';
import '../styles/LandingPage.css';

function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/app/dashboard');
    }
  }, [navigate]);

  return (
    <div className="landing-container">
      <header className="landing-header">
        <div className="logo-landing">
          <strong>Fin</strong>Control
        </div>
        <nav className="landing-nav">
          <Link to="/login" className="login-button">
            <FiLogIn />
            <span>Acessar</span>
          </Link>
          <Link to="/register" className="cta-button-header">
            Criar Conta Grátis <FiArrowRight />
          </Link>
        </nav>
      </header>

      <main>
        <section className="hero-section">
          <div className="hero-content">
            <div className="hero-badge">Sua clareza financeira começa aqui ✨</div>
            <h1>A plataforma inteligente para suas finanças pessoais</h1>
            <p className="hero-subtitle">Organize, planeje e prospere. O FinControl transforma dados financeiros complexos em decisões simples e inteligentes.</p>
            <Link to="/register" className="cta-button-hero">
              Começar Gratuitamente
            </Link>
          </div>
          <div className="hero-image-container">
            <div className="hero-dashboard-mockup">
              <div className="mockup-header">
                <div className="mockup-dots">
                  <span></span><span></span><span></span>
                </div>
                <div className="mockup-title">FinControl — Dashboard</div>
              </div>
              <div className="mockup-body">
                <div className="mockup-sidebar">
                  {['grid_view','sync_alt','pie_chart','bar_chart'].map((icon, i) => (
                    <div key={i} className={`mockup-nav-item${i === 0 ? ' active' : ''}`}>
                      <span className="material-symbols-outlined" style={{fontSize:'16px'}}>{icon}</span>
                    </div>
                  ))}
                </div>
                <div className="mockup-content">
                  <div className="mockup-cards">
                    <div className="mockup-card green">
                      <div className="mockup-card-label">Receitas</div>
                      <div className="mockup-card-value">R$ 8.500</div>
                    </div>
                    <div className="mockup-card red">
                      <div className="mockup-card-label">Despesas</div>
                      <div className="mockup-card-value">R$ 3.200</div>
                    </div>
                    <div className="mockup-card blue">
                      <div className="mockup-card-label">Saldo</div>
                      <div className="mockup-card-value">R$ 5.300</div>
                    </div>
                  </div>
                  <div className="mockup-chart">
                    <div className="mockup-chart-label">Evolução do Saldo</div>
                    <div className="mockup-bars">
                      {[40, 65, 50, 80, 55, 90, 70].map((h, i) => (
                        <div key={i} className="mockup-bar" style={{height: `${h}%`}}></div>
                      ))}
                    </div>
                  </div>
                  <div className="mockup-transactions">
                    <div className="mockup-tx-label">Últimas transações</div>
                    {['Salário','Aluguel','Mercado'].map((tx, i) => (
                      <div key={i} className="mockup-tx-row">
                        <div className="mockup-tx-name">{tx}</div>
                        <div className={`mockup-tx-amount ${i === 0 ? 'income' : 'expense'}`}>
                          {i === 0 ? '+ R$ 5.000' : '- R$ ' + [1500,320][i-1]}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="features-section">
          <h2 className="section-title">Tudo que você precisa, e nada do que você não precisa.</h2>
          <p className="section-subtitle">Ferramentas poderosas, design intuitivo.</p>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><FiBarChart2 /></div>
              <h3>Dashboard Visual</h3>
              <p>Entenda para onde seu dinheiro vai com gráficos e relatórios visuais que fazem sentido.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FiTarget /></div>
              <h3>Orçamentos Inteligentes</h3>
              <p>Defina metas de gastos por categoria e receba alertas para se manter sempre na linha.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FiRepeat /></div>
              <h3>Rotina Automatizada</h3>
              <p>Agende seus salários e contas recorrentes uma vez e deixe o nosso sistema cuidar do resto.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FiShield /></div>
              <h3>Segurança em Primeiro Lugar</h3>
              <p>Seus dados são protegidos com as melhores práticas de segurança. Sua privacidade é nossa prioridade.</p>
            </div>
          </div>
        </section>

        <section className="final-cta-section">
            <h2 className="section-title">Pronto para transformar sua vida financeira?</h2>
            <p className="section-subtitle">Crie sua conta em menos de 60 segundos.</p>
            <Link to="/register" className="cta-button-hero">
              Criar minha conta agora
            </Link>
        </section>
      </main>

      <footer className="landing-footer">
        <div className="logo-landing"><strong>Fin</strong>Control</div>
        <p>© 2025 FinControl. Feito com paixão e código.</p>
      </footer>
    </div>
  );
}

export default LandingPage;